import { render } from "./SearchDropdown.vue?vue&type=template&id=9344f4dc&scoped=true"
import script from "./SearchDropdown.vue?vue&type=script&lang=js"
export * from "./SearchDropdown.vue?vue&type=script&lang=js"

import "./SearchDropdown.vue?vue&type=style&index=0&id=9344f4dc&scoped=true&lang=css"

import exportComponent from "C:\\Assembla\\VIV0006\\root\\dev\\QuizWhiz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9344f4dc"]])

export default __exports__